import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Pagination, Navigation } from 'swiper/modules';
import { MdDomain, MdSpaceDashboard, MdOutlinePriceChange } from "react-icons/md";
import { RiNftLine, RiPagesLine } from "react-icons/ri";
import { BsCurrencyDollar, BsArrow90DegRight } from "react-icons/bs";


import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const tutorialCards = [
  {
    icon: MdSpaceDashboard,
    title: "Dashboard",
    description: "Get a comprehensive overview of your domains, NFTs, and revenue all in one place.",
    path: "/dashboard"
  },
  {
    icon: MdDomain,
    title: "My Domains",
    description: "Manage your Top-Level Domains (TLDs) and Sub-Level Domains (SLDs) efficiently.",
    features: ["Top-Level Domains", "Sub-Level Domains"],
    path: "/dashboard/domain"
  },
  {
    icon: RiPagesLine,
    title: "Mange Pages",
    description: "Create and customize landing pages for your TLDs to showcase and sell SLDs effectively.",
    features: ["Custom Landing Pages", "SLD Sales Portal", "Domain Showcase"],
    path: "/dashboard/manage-pages"
  },
  {
    icon: RiNftLine,
    title: "NFT Launchpad",
    description: "Launch NFT collections, manage airdrops, and track NFT performance metrics.",
    path: "/dashboard/nft-launchpad"
  },
  {
    icon: BsCurrencyDollar,
    title: "Revenue Center",
    description: "Track earnings, manage payouts, and view detailed financial reports.",
    path: "/dashboard/revenue"
  },
  {
    icon: MdOutlinePriceChange,
    title: "Settings & Tools",
    description: "Configure your account settings and access domain management tools.",
    path: "/dashboard/settings"
  }
];

const DashboardCarousel = () => {
  return (
    <div className="w-full max-w-[1200px] mx-auto px-4 ">
      <Swiper
        effect={'coverflow'}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={'auto'}
        initialSlide={1}
        coverflowEffect={{
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        }}
        pagination={true}
        navigation={true}
        modules={[EffectCoverflow, Pagination, Navigation]}
        className="!pb-14 !pt-4"
      >
        {tutorialCards.map((card, index) => (
          <SwiperSlide key={index} className="md:!w-[380px]">
            <div className="h-[320px] rounded-2xl overflow-hidden shadow-lg border border-gray-300">
              <div className="h-full p-6 flex flex-col items-center justify-center text-center 
                            dark:bg-jacarta-800 bg-white
                            dark:text-white text-jacarta-700
                            active-dash-slide">
                <div className="text-4xl mb-4 dark:text-accent text-jacarta-700">
                  {React.createElement(card.icon)}
                </div>
                
                <h3 className="text-xl font-bold mb-3 dark:text-white text-jacarta-700 flex items-center gap-2">
                  {card.title}
                  {card.comingSoon && (
                    <span className="text-xs font-normal bg-accent/5 text-accent px-2 py-1 rounded-full">
                      Coming Soon
                    </span>
                  )}
                </h3>
                
                <p className="text-sm dark:text-white/80 text-jacarta-700 mb-4 line-clamp-2">
                  {card.description}
                </p>
                
                {card.features && (
                  <div className="flex flex-wrap gap-2 justify-center">
                    {card.features.map((feature, idx) => (
                      <span key={idx} 
                            className="text-xs dark:text-accent text-jacarta-700 bg-accent/10 dark:bg-accent/5 px-3 py-1 rounded-full">
                        {feature}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <style jsx global>{`


        .swiper-pagination {
          position: relative;
          margin-top: 20px;
        }

        :root[class~="dark"] .swiper-pagination-bullet {
          background: #02f6d1 !important;
        }

        :root:not([class~="dark"]) .swiper-pagination-bullet {
          background: #131740 !important;
        }

        .swiper-pagination-bullet {
          width: 8px;
          height: 8px;
          opacity: 0.3;
          transition: all 0.3s ease;
        }

        .swiper-pagination-bullet-active {
          opacity: 1;
          width: 20px;
          border-radius: 4px;
        }

        :root[class~="dark"] .swiper-button-prev,
        :root[class~="dark"] .swiper-button-next {
          color: #02f6d1 !important;
        }

        :root:not([class~="dark"]) .swiper-button-prev,
        :root:not([class~="dark"]) .swiper-button-next {
          color: #131740 !important;
        }

        .swiper-button-prev,
        .swiper-button-next {
          width: 40px !important;
          height: 40px !important;
          background: rgba(2, 246, 209, 0.05);
          border-radius: 9999px;
        }

        .swiper-button-prev:hover,
        .swiper-button-next:hover {
          background: rgba(2, 246, 209, 0.1);
        }

        .swiper-button-prev:after,
        .swiper-button-next:after {
          font-size: 1.25rem !important;
          font-weight: bold;
        }


        .swiper-slide-active .h-[320px] {
          outline-offset: 0px;
          transform: scale(1.02);
          color: #fff !important;
        }

        .swiper-slide {
          transition: all 0.3s ease;
        }

        .swiper-slide-active .active-dash-slide {
          background: linear-gradient(to top right, #FF69B4, #804AE4, #02f6d1);
          border: none !important;
          outline: none !important;
        }

         .swiper-slide-active p, .swiper-slide-active h3, .swiper-slide-active svg, .swiper-slide-active span {
          color: #fff !important;
        }

        .swiper-slide-active .border.border-gray-300 {
          border: none;
        }
         
      `}</style>
    </div>
  );
};

export default DashboardCarousel;